var cmsCustomerService = vueIfExists({
mixins: [win.buttonSpinner, win.toggleCollapse, win.reCaptcha],
  el: '#cms-customerservice',
  data: {
  	sharedState: store.state,
  	errors: {
  		general: []
  	},
  	formSent: false,
  	errorType: null
  },
  mounted: function() {
    if (document.forms['customerservice-form'].have_reservation.checked) {
  		this.toggleCollapse(null, { expand: true, target: 'has-booking'});
  	}
  },
  methods: {
  	makeCall: function(event) {
  		event.preventDefault();
  		location.href = 'tel://'+event.target.textContent.replace(' ', '');
  	},
  	submit: function() {
  		var formElements = document.forms['customerservice-form'].elements;
  		var data = {};
  		for (var i = 0; i < formElements.length; i++) {
  			data[formElements[i].name] = formElements[i].value;
  		}
  		this.errors = { general: [] };
   	    this.startBtnLoader(this.$refs['submit-btn']);

  		$ajax.post({
  			url: win.jsonUrl.customerService,
  			data: data,
  			lang: this.sharedState.locale,
  			scope: this,
  			success: function(json) {
  				if (json.errors) {
			  		var formElements = document.forms['customerservice-form'].elements;
  					for (var i = 0; i < json.errors.length; i++) {
  						if (formElements[json.errors[i].field]) {
  							this.errors[json.errors[i].field] = json.errors[i].message;
  						} else {
  							this.errors.general.push(json.errors[i].message);
  						}
  					}
  				} else {
  					this.formSent = true;
  				}
  			},
  			failed: function(errorType) {
  				var message = this.i18n.errors[errorType] ? this.i18n.errors[errorType] : 'Sorry, an error occurred';
				  this.errors.general.push(message);
  			},
  			always: function() {
				  this.stopBtnLoader(this.$refs['submit-btn']);
          $d.scrollto({distance: -20, toElement: gE('customerservice-form')});
  			}
  		});
  	}
  }
});
